import fontBaiJamjureeBold from '~/assets/fonts/BaiJamjuree-Bold.ttf';
import fontBaiJamjureeMedium from '~/assets/fonts/BaiJamjuree-Medium.ttf';
import fontBaiJamjureeRegular from '~/assets/fonts/BaiJamjuree-Regular.ttf';
import fontBaiJamjureeSemiBold from '~/assets/fonts/BaiJamjuree-SemiBold.ttf';
import fontBaiJamjureeBoldItalic from '~/assets/fonts/BaiJamjuree-BoldItalic.ttf';
export const Fonts = {
    baiJamjureeBold: fontBaiJamjureeBold,
    baiJamjureeMedium: fontBaiJamjureeMedium,
    baiJamjureeRegular: fontBaiJamjureeRegular,
    baiJamjureeSemiBold: fontBaiJamjureeSemiBold,
    baiJamjureeBoldItalic: fontBaiJamjureeBoldItalic,
};
